(ns app.front.view.group.reporting.workspaces
  (:require [app.front.ui.content-switcher :as ui-cs]
            [app.front.ui.filter-common :as filter-common]
            [app.front.ui.section :as section]
            [app.front.view.group.admin.subs :as gas]
            [app.front.view.group.reporting.common :as reporting-common]
            [app.front.view.group.reporting.download-button :as rdb]
            [app.front.view.group.reporting.filters :as reporting-filters]
            [app.front.view.group.reporting.form-fields :as reporting-ff]
            [app.front.view.group.reporting.list :as report-list]
            [app.front.view.group.reporting.property-attributes :as reporting-pa]
            [app.query.filter-util :as filter-util]
            [app.reporting.model :as reporting-model]
            [core.front.event :refer [<sub >evt]]
            [core.front.feature-flags :as ff]
            [core.util.util :as util]
            [potpuri.core :as p]
            [re-frame.core-instrumented :as rf]
            [schema.core :as s]))


(def sort-by-options
  [:reporting/submitted-date
   :reporting/issued-date])

(defn default-settings []
  {:categories                   #{}
   :sort-by                      #{(-> sort-by-options first)}
   :selected-form-fields         nil
   :selected-optional-fields     #{}
   :party-roles                  #{}
   :property-attribute-templates []
   :date-selector-mode           #{:reporting.date-range-options/current-month}})

(rf/reg-event-db ::set-selected
  (fn [db [_ k v]]
    (assoc-in db [::data k] v)))

(rf/reg-sub ::data :-> ::data)

(rf/reg-sub ::sort-option
  :<- [::data]
  (fn [data _]
    (or (some->> data
                 ::sort-option
                 ((set sort-by-options)))
        (first sort-by-options))))

(rf/reg-sub
  ::field-tab-selector-index
  :<- [::data]
  (fn [data _]
    (get data ::field-tab-selector-index 0)))

(rf/reg-event-fx ::select-saved-filter
  (fn [{:keys [db]} [_ selected-filter]]
    (let [filter-values      (filter-util/filter-entity->search-values-map selected-filter)
          sort               (->> filter-values :sort-by first)
          date-selector-mode (->> filter-values :date-selector-mode first)]
      {:dispatch-n [[::reporting-common/set-selected-categories (:categories filter-values)]
                    [::reporting-common/set-selected-party-roles (:party-roles filter-values)]]
       :db         (-> db
                       (update ::data #(p/assoc-if %
                                                   ::sort-option sort))
                       (p/assoc-if ::reporting-common/date-selector-mode date-selector-mode
                                   ::reporting-ff/selected (->> (:form-fields filter-values)
                                                                (map-indexed vector)
                                                                (into {}))
                                   ::reporting-common/selected-optional-fields (:optional-fields filter-values)
                                   ::reporting-pa/selected-attributes (:property-attribute-templates filter-values)))})))

(rf/reg-event-db ::initialize-settings
  (fn [db _]
    (let [{:keys [categories
                  sort-by
                  selected-form-fields
                  selected-optional-fields
                  party-roles
                  property-attribute-templates
                  date-selector-mode]}         (default-settings)]
      (-> db
          (update ::data #(assoc %
                                 ::sort-option (first sort-by)))
          (assoc ::reporting-common/date-selector-mode (first date-selector-mode)
                 ::reporting-ff/selected selected-form-fields
                 ::reporting-common/selected-optional-fields selected-optional-fields
                 ::reporting-common/selected-categories categories
                 ::reporting-common/selected-party-roles party-roles
                 ::reporting-pa/selected-attributes property-attribute-templates)))))

(rf/reg-sub ::filter-settings
  :<- [::gas/group]
  :<- [::reporting-common/selected-categories]
  :<- [::reporting-common/selected-optional-fields]
  :<- [::sort-option]
  :<- [::field-tab-selector-index]
  :<- [::reporting-common/date-selector-mode]
  :<- [::reporting-ff/sorted-selected-fields]
  :<- [::reporting-common/selected-party-roles]
  :<- [::reporting-pa/selected-attributes]
  (fn [[group categories optional-fields sort-by field-tab-idx
        date-selector-mode form-fields party-roles property-attributes] _]
    {:sort-by                      #{sort-by}
     :field-tab-idx                #{field-tab-idx}
     :date-selector-mode           #{date-selector-mode}
     :group-id                     #{(:db/id group)}
     :categories                   categories
     :optional-fields              optional-fields
     :form-fields                  form-fields
     :party-roles                  party-roles
     :property-attribute-templates property-attributes}))

(rf/reg-sub ::filters-in-default-state?
  :<- [::filter-settings]
  (fn [filter-settings]
    (= (dissoc filter-settings :group-id) (default-settings))))

(rf/reg-sub ::conditions
  :<- [::gas/group-id]
  :<- [::filter-settings]
  (fn [[group-id filter-settings]]
    (-> filter-settings
        (assoc :group-id #{group-id})
        (filter-common/filter-values->conditions #{:form-fields :property-attribute-templates}))))

(rf/reg-sub ::query
  :<- [::gas/group-id]
  :<- [::reporting-common/selected-permit-types]
  :<- [::reporting-common/selected-optional-fields]
  :<- [::reporting-ff/sorted-selected-fields]
  :<- [::reporting-common/date-range]
  :<- [::sort-option]
  :<- [::reporting-common/selected-party-roles]
  :<- [::reporting-pa/selected-attributes]
  (fn [[group-id permit-types optional-fields
        form-fields [start-date end-date] sort-option party-roles property-attributes] _]
    (-> {:group-id    group-id
         :report-type :reporting/workspaces}
        (p/assoc-if :permit-types (some-> permit-types seq set)
                    :optional-fields optional-fields
                    :form-fields form-fields
                    :start-date start-date
                    :end-date end-date
                    :party-roles (seq party-roles)
                    :sort-by sort-option
                    :property-attribute-templates property-attributes))))


(rf/reg-sub ::property-attributes-enabled?
  :<- [::ff/enabled? :feature-flag.id/reporting-property-attributes]
  :<- [::reporting-common/features]
  (fn [[feature-enabled? features]]
    (and feature-enabled? (:property-management? features))))


(defn sort-selector [tr]
  (let [sort-option (<sub [::sort-option])]
    [:div.flex.items-center.mb-6
     [:span.mr-4.whitespace-nowrap (tr [:reporting/sort-by])]
     [ui-cs/content-switcher {:class     "mt-2 mb-2"
                              :items     sort-by-options
                              :val->str  (comp tr vector)
                              :current   sort-option
                              :on-change #(>evt [::set-selected ::sort-option %])}]]))


(defn view [match]
  (let [{:keys [field-tab-idx] :as settings} (<sub [::filter-settings])
        tr                                   (<sub [::gas/group-tr])
        query                                (<sub [::query])
        tab-label                            #(str (tr [%1]) " " (tr [:reporting/number-selected] [(-> settings %2 count)]))
        permit-types                         (<sub [::gas/group-permit-types])]
    [reporting-common/report-page
     match
     tr
     [:section
      [reporting-filters/filters tr {:filter-type             :filter.type/reporting.workspaces
                                     :filter-settings-sub     ::filter-settings
                                     :default-filters-sub     ::filters-in-default-state?
                                     :conditions-sub          ::conditions
                                     :select-saved-filter-evt ::select-saved-filter
                                     :initialize-settings-evt ::initialize-settings}]]
     [:section
      [:h3.m-0 (tr [:reporting/time-range])]
      [:div.w-full
       [reporting-common/date-range-selector tr "workspace-date-range" reporting-common/date-range-options]]]
     [section/tabbed-section
      {:selected-tab-index (or (first field-tab-idx) 0)
       :on-change          #(>evt [::set-selected ::field-tab-selector-index %])
       :tabs               (cond-> [{:label-text (tab-label :reporting/permit-type :permit-types)
                                     :content    [reporting-common/permit-type-selector tr]}]
                             (ff/enabled? :feature-flag.id/superdomain-can-manage-forms)
                             (conj {:label-text (tab-label :reporting/permit-categories :categories)
                                    :content    [reporting-common/category-selector tr false]}
                                   {:label-text (tab-label :reporting/form-fields :form-fields)
                                    :content    [reporting-ff/form-field-selector tr false]})
                             true
                             (conj {:label-text (tab-label :reporting/related-parties :party-roles)
                                    :content    [reporting-common/related-parties-selector tr]}
                                   {:label-text (tab-label :reporting/optional-fields :optional-fields)
                                    :content    [reporting-common/optional-field-selector tr :workspaces
                                                 (cond->> (reporting-model/workspace-optional-fields permit-types)
                                                   (not (ff/enabled? :feature-flag.id/property-db-units))
                                                   (remove #{:reporting/application-unit-type-and-number})
                                                   (not (ff/enabled? :feature-flag.id/express-issuance))
                                                   (remove #{:reporting/express-issuance}))]})
                             (<sub [::property-attributes-enabled?])
                             (conj {:label-text (tab-label :reporting/property-attributes :property-attribute-templates)
                                    :content    [reporting-pa/property-attribute-selector tr]}))}]
     [sort-selector tr]
     [report-list/list-section (util/mmap {:report-type :reporting/workspaces} tr)]
     [rdb/generate-button (util/mmap query tr)]]))


(def route
  {:name        :view/group.reporting.workspaces
   :view        view
   :parameters  {:path {:group-id s/Int}}
   :controllers [{:parameters {:path [:group-id]}
                  :start      (fn [params]
                                (let [group-id (-> params :path :group-id)]
                                  (>evt [::reporting-filters/fetch-saved-filters group-id])
                                  (>evt [::reporting-common/init group-id (first reporting-common/date-range-options)])))
                  :stop       (fn []
                                (>evt [::initialize-settings]))}]})
